import { ButtonBase } from '@mui/material';
import './PriceDownText.scss';

interface PriceDownTextProps {
  title: string;
  description: string;
  price: string | React.ReactNode;
  onClick: () => void;
}

const PriceDownText = ({
  title,
  description,
  price,
  onClick,
}: PriceDownTextProps) => {
  return (
    <ButtonBase className="dish dish--price-down-text" onClick={onClick}>
      <div className="dish__body">
        <h3 className="dish__title">{title}</h3>
        <p className="dish__description">{description}</p>
        <p className="dish__price">{price}</p>
      </div>
    </ButtonBase>
  );
};

export default PriceDownText;
